import React, { useEffect, useRef } from "react";
import useAxios from "../../Hooks/useAxios";

function AuthDevices() {
  const request = useAxios();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const authenticate = async () => {
      try {
        const res = await request({
          method: "POST",
          url: "/gps-devices/authenticate",
          body: {
            username: "exhibit",
            password: "@Exhsol.@2025",
          },
          send_token: false,
          show_loading: false,
          show_success: false,
          show_error: false, // ← Changed this to false
        });

        console.log("Full response:", res); // ← Add this line

        if (res === "error") {
          console.error("Authentication failed");
          return;
        }

        const { token, userGuid } = res?.data || {};

        if (token && userGuid) {
          localStorage.setItem("gps_token", token);
          localStorage.setItem("gps_userGuid", userGuid);
          console.log("✅ Token and UserGuid saved");
        } else {
          console.warn("⚠️ Token or UserGuid missing in response:", res);
        }
      } catch (error) {
        console.error("❌ Auth error:", error);
      }
    };

    authenticate();
  }, [request]);

  return <div className="p-6"></div>;
}

export default AuthDevices;